<template>
  <div class="chart healthy-meters-chart" ref="chartContainer">

  </div>
</template>

<script>
require('@chartisan/chartjs');
export default {
  name: "HealthyMetersChart",
  props: {
    url: {
      type: String,
      required: true,
    },
    height: {
      type: String,
      default: "auto",
    },
    width: {
      type: String,
      default: "auto"
    }
  },
  data(){
    return {
      chart: {}
    };
  },
  mounted() {
    if(this.height !== "auto"){
      this.$refs.chartContainer.style.height = this.height;
    }
    if(this.width !== "auto"){
      this.$refs.chartContainer.style.width = this.width;
    }
    this.chart = new Chartisan({
      el: this.$refs.chartContainer,
      url: this.url,
      hooks: new ChartisanHooks()
          .responsive()
          .colors()
          .legend(false)
          .title('Healthy Meters')
          .datasets('doughnut')
          .pieColors(["green", "red"])
          .options({
            options: {
              cutoutPercentage: 80,
            }
          })
    });
  }
}
</script>

<style scoped>

</style>
